import React, { useState, useEffect, useContext } from "react";
import { DataContext } from "../contex/DataContext";
import axios from "axios";
import { storeColors } from "../json/colores";
import "../styles/items.css";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import { SpinnerModal } from "../components";
import { buildApiUrl } from "../config/api";

export const Items = () => {
  const { storaName, allStores } = useContext(DataContext);

  // Obtener OrganizationID del localStorage
  const organizationID = localStorage.getItem("organizationID");

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [xlsxFile, setXlsxFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedStore, setSelectedStore] = useState([]);
  const [selectedStoreSelect, setSelectedStoreSelect] = useState("");
  const [selectedShopId, setSelectedShopId] = useState(""); // ShopId de la tienda seleccionada
  const [isEditing, setIsEditing] = useState(false);
  const [spinnerModal, setSpinnerModal] = useState(false);
  const [editingStoreName, setEditingStoreName] = useState(false);
  const [newStoreName, setNewStoreName] = useState("");
  const [selectedArticlesCheckbox, setSelectedArticlesCheckbox] = useState([]);
  const [sortField, setSortField] = useState("");

  const [dataArticle, setDataArticle] = useState({
    NameStore: "",
    SkuStore: "",
    NameZoho: "",
    SkuZoho: "",
    Tax_id: "",
    taxRate: "",
    isActive: false,
    stockLimit: 10,
  });

  // UseEffect para actualizar selectedStoreSelect cuando cambia storaName
  useEffect(() => {
    if (Array.isArray(storaName) && storaName.length > 0) {
      setSelectedStoreSelect(storaName[0].name);
      setSelectedShopId(storaName[0].shopId); // Establecer ShopId inicial
    }
  }, [storaName]);

  // Datos crudos (Name/Ecommerce) de la tienda actualmente seleccionada
  const selectedStoreData = allStores?.find(
    (store) => store.ShopId === selectedShopId,
  );
  const selectedStoreEcommerce = selectedStoreData?.Ecommerce || "";
  const selectedStoreDisplayName =
    selectedStoreData?.Name || selectedStoreData?.Ecommerce || "";

  // UseEffect para hacer desaparecer el mensaje de error después de 5 segundos
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 1500);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const articlesPerPage = 15;

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleSortChange = (e) => {
    setSortField(e.target.value);
    setCurrentPage(1);
  };

  const filteredSelectedStore = selectedStore?.filter((articulo) =>
  articulo?.NameStore?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
  articulo?.SkuStore?.toLowerCase().includes(searchTerm?.toLowerCase())
);

  const sortedSelectedStore = sortField
    ? [...(filteredSelectedStore ?? [])].sort((a, b) =>
        (a?.[sortField] ?? "").localeCompare(b?.[sortField] ?? "", "es", {
          sensitivity: "base",
        }),
      )
    : filteredSelectedStore;

  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = sortedSelectedStore?.slice(
    indexOfFirstArticle,
    indexOfLastArticle,
  );

  const totalPages = Math.ceil(sortedSelectedStore?.length / articlesPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const nextPage = () =>
    setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
  const prevPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));

  const getPageNumbers = () => {
    let startPage, endPage;

    if (totalPages <= 3) {
      startPage = 1;
      endPage = totalPages;
    } else {
      if (currentPage <= 2) {
        startPage = 1;
        endPage = 3;
      } else if (currentPage + 1 >= totalPages) {
        startPage = totalPages - 2;
        endPage = totalPages;
      } else {
        startPage = currentPage - 1;
        endPage = currentPage + 1;
      }
    }

    return Array.from(
      { length: endPage - startPage + 1 },
      (_, index) => startPage + index,
    );
  };

  const pageNumbers = getPageNumbers();

  // NUEVO: Botón para sincronizar con Zoho
  const handleSyncStock = async () => {
    if (!organizationID) {
      alert("No se encontró la OrganizationID en localStorage");
      return;
    }

    try {
      await axios.post(buildApiUrl("/stock/sync-stock"), {
        organizationId: organizationID,
      });
      alert("Sincronización de stock completada");
    } catch (error) {
      console.error("Error al sincronizar el stock:", error);
      alert("Ocurrió un error al sincronizar el stock.");
    }
  };

  // Función para editar el nombre de la tienda
  const handleEditStoreName = () => {
    setNewStoreName(selectedStoreSelect);
    setEditingStoreName(true);
  };

  // Función para guardar el nuevo nombre de la tienda
  const handleSaveStoreName = async () => {
    if (!newStoreName.trim()) {
      alert("El nombre no puede estar vacío");
      return;
    }

    const currentStore = allStores?.find(
      (s) => (s.Name || s.Ecommerce) === selectedStoreSelect,
    );

    if (!currentStore) {
      alert("No se encontró la tienda seleccionada");
      return;
    }

    try {
      const response = await axios.put(
        buildApiUrl("/ep_StoreEcart/updateName"),
        {
          storeId: currentStore._id,
          newName: newStoreName.trim(),
          organizationID: organizationID,
        },
      );

      if (response.status === 200) {
        alert("Nombre actualizado exitosamente");
        setEditingStoreName(false);
        window.location.reload(); // Recargar para ver los cambios
      }
    } catch (error) {
      console.error("Error actualizando nombre:", error);
      alert("Error al actualizar el nombre de la tienda");
    }
  };

  // Función para cancelar la edición
  const handleCancelEditStoreName = () => {
    setEditingStoreName(false);
    setNewStoreName("");
  };

  /*llamo al articulo para que se completen en los inputs de modo editar */
  const handleRowClick = async (articulo) => {
    setIsEditing(true);
    setSelectedArticle(articulo);
    setDataArticle({
      NameStore: "",
      SkuStore: "",
      NameZoho: "",
      SkuZoho: "",
      Tax_id: "",
      taxRate: "",
      isActive: false,
      stockLimit: 10,
    });

    try {
      const encodedSkuStore = await encodeURIComponent(articulo.SkuStore);
      const res = await axios.get(
        `${buildApiUrl("/ep_ItemZohoEcart/getItemBySku")}?OrganizationID=${articulo.OrganizationID}&SkuStore=${encodedSkuStore}&Store=${articulo.Store}`,
      );
      setDataArticle({
        NameStore: articulo.NameStore,
        SkuStore: res.data.SkuStore,
        NameZoho: res.data.NameZoho,
        SkuZoho: res.data.SkuZoho,
        Tax_id: res.data.Tax_id,
        taxRate: res.data.taxRate,
        isActive: articulo.isActive ?? false,
        stockLimit: res.data.stockLimit ?? 10,
      });
    } catch (error) {
      setDataArticle({
        NameStore: articulo.NameStore,
        SkuStore: articulo.SkuStore,
        isActive: articulo.isActive ?? false,
      });
    }
  };

  /* Selecciona o deselecciona un articulo de la lista mediante checkbox */
  const handleToggleArticleCheckbox = (articulo, e) => {
    e.stopPropagation();
    setSelectedArticlesCheckbox((prevSelected) =>
      prevSelected.some((item) => item.SkuStore === articulo.SkuStore)
        ? prevSelected.filter((item) => item.SkuStore !== articulo.SkuStore)
        : [...prevSelected, articulo],
    );
  };

  const isArticleChecked = (articulo) =>
    selectedArticlesCheckbox.some((item) => item.SkuStore === articulo.SkuStore);

  const handleZohoChange = (e) => {
    const { name, value } = e.target;
    setDataArticle({
      ...dataArticle,
      [name]: value,
    });
  };

  /*Boton de exportar */
  const handelExport = async () => {
    if (!organizationID) {
      console.error("OrganizationID no está disponible en localStorage.");
      return;
    }

    try {
      const response = await axios.get(
        `${buildApiUrl("/ep_ItemManagerEcart")}?OrganizationID=${organizationID}&Store=${selectedStoreEcommerce}&ShopId=${selectedShopId}`,
        { responseType: "arraybuffer" },
      );

      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(blob, "exported_items.xlsx");
    } catch (error) {
      console.error("Error al exportar los artículos:", error.message);
    }
  };

  /* Lee el archivo xlsx en el navegador y extrae los SKUs de la columna SkuStore/Sku/SKU */
  const getSkusFromXlsxFile = async (file) => {
    const arrayBuffer = await file.arrayBuffer();
    const workbook = XLSX.read(arrayBuffer, { type: "array" });
    const firstSheet = workbook.Sheets[workbook.SheetNames[0]];
    const rows = XLSX.utils.sheet_to_json(firstSheet, { defval: "" });

    return rows
      .map((row) => {
        const skuKey = Object.keys(row).find((key) =>
          ["skustore", "sku"].includes(key.trim().toLowerCase()),
        );
        return skuKey ? String(row[skuKey]).trim() : "";
      })
      .filter((sku) => sku !== "");
  };

  // Función para importar un archivo CSV a la API
  const handelImport = async () => {
    if (!organizationID || !xlsxFile) {
      console.error("Falta OrganizationID o archivo CSV.");
      return;
    }

    try {
      const skusFromFile = await getSkusFromXlsxFile(xlsxFile);

      const duplicatedWithExisting = skusFromFile.filter((sku) =>
        isSkuDuplicate(sku),
      );

      if (duplicatedWithExisting.length > 0) {
        alert(
          `El archivo contiene SKUs que ya existen en esta tienda y no se puede importar:\n${[
            ...new Set(duplicatedWithExisting),
          ].join(", ")}`,
        );
        return;
      }
    } catch (error) {
      console.error("Error al leer el archivo xlsx:", error.message);
      alert("No se pudo leer el archivo xlsx para validar los SKUs.");
      return;
    }

    const formData = new FormData();
    formData.append("OrganizationID", organizationID);
    formData.append("Store", selectedStoreSelect);
    formData.append("ShopId", selectedShopId);
    formData.append("xlsxFile", xlsxFile);

    setSpinnerModal(true);

    try {
      await axios.put(
        buildApiUrl("/ep_ItemManagerEcart"),
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      alert("Archivo CSV importado correctamente.");
    } catch (error) {
      console.error("Error al importar el archivo CSV:", error.message);
      alert("Error al importar el archivo CSV. Por favor, intenta nuevamente.");
    } finally {
      setSpinnerModal(false);
    }
  };

  // Función para manejar el cambio en el input de archivo CSV
  const handleFileChange = (event) => {
    setXlsxFile(event.target.files[0]);
  };

  useEffect(() => {
    if (selectedShopId) {
      obtengoArticulos(selectedShopId);
    }
  }, [selectedShopId]);

  const obtengoArticulos = async (shopId) => {
    try {
      const res = await axios.get(
        `${buildApiUrl("/ep_ItemStoreEcart/getItems")}?OrganizationID=${organizationID}&ShopId=${shopId}`,
      );
      setSelectedStore(res.data);
    } catch (error) {
      console.error("Error al obtener artículos:", error);
    }
  };

  const handleStoreSelection = async (e) => {
    const displayName = e.target.value;
    setSelectedStoreSelect(displayName);

    // Buscar el ShopId correspondiente al nombre seleccionado
    const selectedStoreData = storaName.find((s) => s.name === displayName);
    const shopId = selectedStoreData?.shopId;
    setSelectedShopId(shopId);

    setDataArticle({
      NameStore: "",
      SkuStore: "",
      NameZoho: "",
      SkuZoho: "",
      Tax_id: "",
      taxRate: "",
      isActive: false,
      stockLimit: 10,
    });
  };

  /*Actualiza el estado para determinar el color en el select */
  useEffect(() => {
    const selectElement = document.getElementById("storeSelect");

    // Función para aplicar color al select
    const applyColor = (element) => {
      const selectedOption = element.options[element.selectedIndex];
      const color = selectedOption.getAttribute("data-color");
      if (color) {
        element.style.color = color;
      }
    };

    // Función para manejar el cambio
    const handleChange = (e) => {
      applyColor(e.target);
    };

    // Asegúrate de que el select tenga opciones antes de aplicar el color
    const applyColorWhenReady = () => {
      if (selectElement.options.length > 0) {
        applyColor(selectElement);
      } else {
        setTimeout(applyColorWhenReady, 100);
      }
    };

    // Añadir evento de cambio
    selectElement.addEventListener("change", handleChange);

    // Aplicar color al primer elemento al cargar
    applyColorWhenReady();

    // Cleanup function
    return () => {
      selectElement.removeEventListener("change", handleChange);
    };
  }, [storaName]);

  /* modo nuevo */
  const handleNuevoClick = () => {
    setIsEditing(false);
    setDataArticle({
      NameStore: "",
      SkuStore: "",
      NameZoho: "",
      SkuZoho: "",
      Tax_id: "",
      taxRate: "",
      isActive: false,
      stockLimit: 10,
    });
  };

  /* modo editar */
  const handleEditarClick = () => {
    setIsEditing(true);
  };

  /* Verifica si un SKU ya existe entre los articulos de la tienda seleccionada */
  const isSkuDuplicate = (sku) =>
    selectedStore?.some(
      (articulo) =>
        articulo.SkuStore?.trim().toLowerCase() === sku?.trim().toLowerCase(),
    );

  /* creo un nuevo producto en el articulo */
  const handleNuevo = async (e) => {
    e.preventDefault();

    if (isSkuDuplicate(dataArticle.SkuStore)) {
      setErrorMessage(
        `El SKU "${dataArticle.SkuStore}" ya existe en esta tienda.`,
      );
      return;
    }

    setSelectedArticle(null);

    const newArticle = {
      NameStore: dataArticle.NameStore,
      SkuStore: dataArticle.SkuStore,
      OrganizationID: organizationID,
      Store: selectedStoreEcommerce,
      ShopId: selectedShopId,
      NameZoho: dataArticle.NameZoho,
      SkuZoho: dataArticle.SkuZoho,
      Tax_id: dataArticle.Tax_id,
      taxRate: dataArticle.taxRate,
      isActive: dataArticle.isActive,
      stockLimit: dataArticle.stockLimit,
    };

    try {
      const response = await axios.post(
        buildApiUrl("/ep_ItemManagerEcart/createItem"),
        newArticle,
      );

      // Actualizar el estado del artículo en selectedStore
      setSelectedStore((prevSelectedStore) => [
        ...prevSelectedStore,
        newArticle,
      ]);

      // Limpiar el formulario
      setDataArticle({
        NameStore: "",
        SkuStore: "",
        NameZoho: "",
        SkuZoho: "",
        Tax_id: "",
        taxRate: "",
        isActive: false,
        stockLimit: 10,
      });

      setSelectedArticle(null);
    } catch (error) {
      setErrorMessage(error.response.data);
    }
  };

  /*edita el articulo existente (uno o varios si hay seleccion por checkbox) */
  const handleEditar = async (e) => {
    e.preventDefault();

    const isBulkEdit = selectedArticlesCheckbox.length > 1;
    const articlesToUpdate = isBulkEdit
      ? selectedArticlesCheckbox
      : selectedArticle
        ? [selectedArticle]
        : [];

    if (articlesToUpdate.length === 0) {
      setErrorMessage("Selecciona un artículo para editar.");
      return;
    }

    setSpinnerModal(true);

    try {
      const updatedArticles = await Promise.all(
        articlesToUpdate.map(async (articulo) => {
          const newArticle = {
            NameStore: isBulkEdit ? articulo.NameStore : dataArticle.NameStore,
            SkuStore: articulo.SkuStore,
            OrganizationID: organizationID,
            Store: selectedStoreEcommerce,
            ShopId: selectedShopId,
            NameZoho: dataArticle.NameZoho,
            SkuZoho: dataArticle.SkuZoho,
            Tax_id: dataArticle.Tax_id,
            taxRate: dataArticle.taxRate,
            isActive: isBulkEdit ? articulo.isActive : dataArticle.isActive,
            stockLimit: dataArticle.stockLimit,
          };

          await axios.put(
            buildApiUrl("/ep_ItemManagerEcart/updateItem"),
            newArticle,
          );

          return newArticle;
        }),
      );

      // Actualizar el estado de los artículos en selectedStore
      setSelectedStore((prevSelectedStore) =>
        prevSelectedStore.map((article) => {
          const updated = updatedArticles.find(
            (item) => item.SkuStore === article.SkuStore,
          );
          return updated ?? article;
        }),
      );

      // Limpiar el formulario
      setDataArticle({
        NameStore: "",
        SkuStore: "",
        NameZoho: "",
        SkuZoho: "",
        Tax_id: "",
        taxRate: "",
        isActive: false,
        stockLimit: 10,
      });
      setSelectedArticle(null);
      setSelectedArticlesCheckbox([]);
    } catch (error) {
      setErrorMessage(error.response?.data ?? "Error al editar el/los artículo(s).");
    } finally {
      setSpinnerModal(false);
    }
  };

  /*elimina masivamente los articulos seleccionados por checkbox */
  const handleEliminarSeleccionados = async () => {
    if (selectedArticlesCheckbox.length === 0) {
      alert("Selecciona al menos un artículo para eliminar.");
      return;
    }

    const confirmDelete = window.confirm(
      `¿Seguro que deseas eliminar ${selectedArticlesCheckbox.length} artículo(s)? Esta acción no se puede deshacer.`,
    );
    if (!confirmDelete) return;

    setSpinnerModal(true);

    try {
      await axios.put(buildApiUrl("/ep_ItemStoreEcart/remove"), {
        itemIds: selectedArticlesCheckbox.map((articulo) => articulo._id),
      });

      const deletedSkus = new Set(
        selectedArticlesCheckbox.map((articulo) => articulo.SkuStore),
      );

      setSelectedStore((prevSelectedStore) =>
        prevSelectedStore.filter((articulo) => !deletedSkus.has(articulo.SkuStore)),
      );
      setSelectedArticlesCheckbox([]);
      if (selectedArticle && deletedSkus.has(selectedArticle.SkuStore)) {
        setSelectedArticle(null);
      }
    } catch (error) {
      console.error("Error al eliminar los artículos:", error);
      alert("Ocurrió un error al eliminar los artículos seleccionados.");
    } finally {
      setSpinnerModal(false);
    }
  };

  /*activa o desactiva masivamente los articulos seleccionados por checkbox */
  const handleActualizarEstadoSeleccionados = async (isActive) => {
    if (selectedArticlesCheckbox.length === 0) {
      alert("Selecciona al menos un artículo para actualizar.");
      return;
    }

    setSpinnerModal(true);

    try {
      await axios.put(buildApiUrl("/ep_ItemStoreEcart/status"), {
        itemIds: selectedArticlesCheckbox.map((articulo) => articulo._id),
        isActive,
      });

      const updatedSkus = new Set(
        selectedArticlesCheckbox.map((articulo) => articulo.SkuStore),
      );

      setSelectedStore((prevSelectedStore) =>
        prevSelectedStore.map((articulo) =>
          updatedSkus.has(articulo.SkuStore)
            ? { ...articulo, isActive }
            : articulo,
        ),
      );

      // Si el artículo abierto en el panel de edición fue actualizado, sincroniza
      // el switch para que no quede mostrando un valor obsoleto que luego se
      // reenviaría al backend y revertiría el cambio recién hecho.
      if (selectedArticle && updatedSkus.has(selectedArticle.SkuStore)) {
        setSelectedArticle((prev) => ({ ...prev, isActive }));
        setDataArticle((prev) => ({ ...prev, isActive }));
      }

      setSelectedArticlesCheckbox([]);
    } catch (error) {
      console.error("Error al actualizar el estado de los artículos:", error);
      alert("Ocurrió un error al actualizar el estado de los artículos seleccionados.");
    } finally {
      setSpinnerModal(false);
    }
  };

  const isBulkEditMode = isEditing && selectedArticlesCheckbox.length > 1;

  return (
    <div className="articles_container">
      {spinnerModal && <SpinnerModal />}
      <div className="articles_container_h2">
        <h2>
          Artículos en:{" "}
          {!editingStoreName ? (
            <select
              name="select"
              onChange={handleStoreSelection}
              id="storeSelect"
            >
              {storaName ? (
                storaName.map((store, index) => (
                  <option
                    key={index}
                    value={store.name}
                    style={{ color: storeColors[store.ecommerce] }}
                    data-color={storeColors[store.ecommerce]}
                  >
                    {store.ecommerce}
                  </option>
                ))
              ) : (
                <option>Cargando...</option>
              )}
            </select>
          ) : (
            selectedStoreEcommerce
          )}{" "}
          para la tienda {selectedStoreDisplayName}
        </h2>
        {!editingStoreName ? (
          <button
            onClick={handleEditStoreName}
            style={{
              marginLeft: "10px",
              padding: "5px 15px",
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
            }}
          >
            ✏️ Editar nombre de la tienda
          </button>
        ) : (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <input
              type="text"
              value={newStoreName}
              onChange={(e) => setNewStoreName(e.target.value)}
              placeholder="Nuevo nombre de tienda"
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ddd",
                minWidth: "250px",
              }}
            />
            <button
              onClick={handleSaveStoreName}
              style={{
                padding: "5px 15px",
                backgroundColor: "#4caf50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              ✓ Guardar
            </button>
            <button
              onClick={handleCancelEditStoreName}
              style={{
                padding: "5px 15px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              ✗ Cancelar
            </button>
          </div>
        )}
      </div>

      <div className="articles_btn">
        <input
          className="upload-box"
          type="file"
          accept=".xlsx"
          onChange={handleFileChange}
          style={{ marginRight: "15px" }}
        />
        <button onClick={handelImport}>Importar</button>
        <button onClick={handelExport}>Exportar</button>
        <button onClick={handleSyncStock}>Sincronizar Stock</button>
      </div>

      <div className="articles_subcontainer">
        <div className="articles_subcontainer_tabla">
          <div className="articles_nameStore">
            <select
              value={sortField}
              onChange={handleSortChange}
              className="input"
            >
              <option value="">Ordenar por...</option>
              <option value="NameStore">Nombre</option>
              <option value="SkuStore">Sku</option>
            </select>
            <input
              type="text"
              placeholder="Buscar..."
              value={searchTerm}
              onChange={handleSearchChange}
              className="input"
            />
          </div>
          <div className="articles_tabla">
            <table className="articles_table">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">Nombre en tienda</th>
                  <th scope="col">Sku en Tienda</th>
                  <th>Activo</th>
                  <th>Stock Limit</th>
                </tr>
              </thead>
              <tbody>
                {currentArticles?.map((articulo, index) => (
                  <tr
                    className="articles_tabla_tr"
                    key={index}
                    onClick={() => handleRowClick(articulo)}
                  >
                    <td onClick={(e) => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        checked={isArticleChecked(articulo)}
                        onChange={(e) => handleToggleArticleCheckbox(articulo, e)}
                      />
                    </td>
                    <td>{articulo.NameStore}</td>
                    <td>{articulo.SkuStore}</td>
                    <td>{articulo.isActive ? "Sí" : "No"}</td>
                    <td>{articulo.stockLimit}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="pagination">
            <button
              onClick={prevPage}
              disabled={currentPage === 1}
              className="page_button"
            >
              Previous
            </button>
            {pageNumbers.map((number) => (
              <button
                key={number}
                onClick={() => paginate(number)}
                className={`page_button ${currentPage === number ? "active" : ""}`}
              >
                {number}
              </button>
            ))}
            <button
              onClick={nextPage}
              disabled={currentPage === totalPages}
              className="page_button"
            >
              Next
            </button>
          </div>
        </div>
        <div className="articles_subcontainer_button">
          <div className="secion_btn">
            <button
              onClick={handleNuevoClick}
              className={!isEditing ? "active" : ""}
            >
              Nuevo
            </button>
            <button
              onClick={handleEditarClick}
              className={isEditing ? "active" : ""}
            >
              Editar
              {selectedArticlesCheckbox.length > 1
                ? ` (${selectedArticlesCheckbox.length})`
                : ""}
            </button>
            <button
              onClick={handleEliminarSeleccionados}
              disabled={selectedArticlesCheckbox.length === 0}
              className="btn-eliminar"
            >
              Eliminar
              {selectedArticlesCheckbox.length > 0
                ? ` (${selectedArticlesCheckbox.length})`
                : ""}
            </button>
            <button
              onClick={() => handleActualizarEstadoSeleccionados(true)}
              disabled={selectedArticlesCheckbox.length === 0}
              className="btn-activar"
            >
              Activar
              {selectedArticlesCheckbox.length > 0
                ? ` (${selectedArticlesCheckbox.length})`
                : ""}
            </button>
            <button
              onClick={() => handleActualizarEstadoSeleccionados(false)}
              disabled={selectedArticlesCheckbox.length === 0}
              className="btn-desactivar"
            >
              Desactivar
              {selectedArticlesCheckbox.length > 0
                ? ` (${selectedArticlesCheckbox.length})`
                : ""}
            </button>
          </div>

          <div className="articles_subcontainer_input">
            <div className="articles_input">
              <div className="articles_input_info_zoho">
                <div className="articles_input_info">
                  <div className="articles_input_info_input_left">
                    <label className="form-label">Estado del Artículo</label>
                    <div className="toggle-switch-container">
                      <label className="toggle-switch">
                        <input
                          type="checkbox"
                          checked={dataArticle.isActive}
                          disabled={isBulkEditMode}
                          onChange={(e) =>
                            setDataArticle({
                              ...dataArticle,
                              isActive: e.target.checked,
                            })
                          }
                        />
                        <span className="toggle-slider"></span>
                      </label>
                      <span
                        className={`toggle-status-text ${
                          dataArticle.isActive ? "active" : "inactive"
                        }`}
                      >
                        {dataArticle.isActive ? "✓ Activo" : "✗ Inactivo"}
                      </span>
                    </div>
                  </div>

                  <div className="articles_input_info_input_right">
                    <label className="form-label">Stock Limit</label>
                    <input
                      type="number"
                      className="form-control"
                      name="stockLimit"
                      value={dataArticle.stockLimit}
                      onChange={(e) => {
                        const value = Number(e.target.value);
                        setDataArticle({ ...dataArticle, stockLimit: value });
                      }}
                    />
                  </div>
                </div>
                <div className="articles_input_info_input_left">
                  <label className="form-label">Nombre en tienda</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Name-Tienda"
                    name="NameStore"
                    value={
                      isBulkEditMode ? "(varios artículos)" : dataArticle.NameStore
                    }
                    onChange={handleZohoChange}
                    disabled={isBulkEditMode}
                  />
                </div>
                <div className="articles_input_info_input_right">
                  <label className="form-label">Sku en Tienda</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Sku-Tienda"
                    name="SkuStore"
                    value={
                      isBulkEditMode ? "(varios artículos)" : dataArticle.SkuStore
                    }
                    onChange={handleZohoChange}
                    disabled={isEditing || isBulkEditMode}
                  />
                </div>
              </div>
              {isBulkEditMode && (
                <p className="bulk-edit-hint">
                  Editando {selectedArticlesCheckbox.length} artículos seleccionados.
                  Los cambios de Zoho y Stock Limit se aplicarán a todos.
                </p>
              )}
              {errorMessage && <p className="error-message">{errorMessage}</p>}

              <div className="articles_input_info">
                <div className="articles_input_info_input_left">
                  <label className="form-label">Nombre en Zoho</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Name-Zoho"
                    name="NameZoho"
                    value={dataArticle.NameZoho}
                    onChange={handleZohoChange}
                  />
                </div>
                <div className="articles_input_info_input_right">
                  <label className="form-label">Sku en Zoho</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Sku-Zoho"
                    name="SkuZoho"
                    value={dataArticle.SkuZoho}
                    onChange={handleZohoChange}
                  />
                </div>
              </div>

              <div className="articles_input_info">
                <div className="articles_input_info_input_left">
                  <label className="form-label">Tax id</label>
                  <input
                    type="text"
                    className="form-control"
                    id="Tax_id"
                    name="Tax_id"
                    value={dataArticle.Tax_id}
                    onChange={handleZohoChange}
                  />
                </div>
                <div className="articles_input_info_input_right">
                  <label className="form-label">Tax Rate</label>
                  <input
                    type="text"
                    className="form-control"
                    id="taxRate"
                    name="taxRate"
                    value={dataArticle.taxRate}
                    onChange={handleZohoChange}
                  />
                </div>
              </div>
            </div>
            <div className="articles_btn_btn">
              {isEditing ? (
                <button onClick={handleEditar}>Editar</button>
              ) : (
                <button onClick={handleNuevo}>Crear Nuevo</button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
